import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class MultiTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private files: string[]) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    if (this.files.length === 0) {
      return of({} as TranslationObject);
    }

    return forkJoin(
      this.files.map(file =>
        this.http
          .get<TranslationObject>(`i18n/${lang}/${file}.json`)
          .pipe(catchError(() => of({} as TranslationObject)))
      )
    ).pipe(
      map(parts => parts.reduce((acc, part) => deepMerge(acc, part), {} as TranslationObject))
    );
  }
}

function deepMerge(target: TranslationObject, source: TranslationObject): TranslationObject {
  const result: TranslationObject = { ...target };

  for (const key of Object.keys(source)) {
    const sourceValue = source[key];
    const targetValue = result[key];

    if (isPlainObject(sourceValue) && isPlainObject(targetValue)) {
      result[key] = deepMerge(targetValue as TranslationObject, sourceValue as TranslationObject);
    } else {
      result[key] = sourceValue;
    }
  }

  return result;
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
